export enum WidgetAssessmentStatus {
  COMPLETED = "current_window_completed",
  ONGOING = "current_window_ongoing",
  SCHEDULED = "next_window_scheduled",
  PAST_COMPLETED = "previous_window_completed",
  PAST_INCOMPLETE = "previous_window_incomplete",
  NO_ACTIVE = "no_active_window_no_scheduled",
}